import { render } from "./ListeHsCode.vue?vue&type=template&id=12207cc6&ts=true"
import script from "./ListeHsCode.vue?vue&type=script&lang=ts"
export * from "./ListeHsCode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__